<template>
    <div class="payPopout">
        <div class="paychaper">
            <i @click="paymentguan" class="el-icon-close"></i>
            <div class="paycoin">
                <div class="pay">
                    <div class="pays" @click="changepay(1)" :class="{ payactive: isactive == 1 }">
                        <div class="tag" :class="{ tagis: isactive == 1 }">First choice</div>
                        <div class="paycointit">
                            <image src="@/images/coin.svg" mode=""></image>100
                        </div>
                        <div class="cen">US＄1.0</div>
                        <div class="bot">20 chapters after purchase</div>
                    </div>
                    <div class="pays" @click="changepay(2)" :class="{ payactive: isactive == 2 }">
                        <div class="tag" :class="{ tagis: isactive == 2 }">Most popular</div>
                        <div class="paycointit">
                            <image src="@/images/coin.svg" mode=""></image>250
                        </div>
                        <div class="cen">US＄2.5</div>
                        <div class="bot">50 chapters after purchase</div>

                    </div>
                    <div class="pays" @click="changepay(3)" :class="{ payactive: isactive == 3 }">
                        <div class="paycointit">
                            <image src="@/images/coin.svg" mode=""></image>500
                        </div>
                        <div class="cen">US＄5.0</div>
                        <div class="bot">100 chapters after purchase</div>

                    </div>
                    <div class="pays" @click="changepay(4)" :class="{ payactive: isactive == 4 }">
                        <div class="paycointit">
                            <image src="@/images/coin.svg" mode=""></image>5000
                        </div>
                        <div class="cen">US＄50</div>
                        <div class="bot">1000 chapters after purchase</div>
                    </div>
                </div>
                <el-button @click="pay" :loading="disabled" class="button" type="primary">Recharge</el-button>
            </div>
            <div class="warn">
                <i class="el-icon-warning-outline"></i>
                <p>Coins can be used to skip ads, unlock chapters and support the translators/editors.
                    Purchased Coins don't expire, are non-transferrable, and can be used for reading.</p>
            </div>
        </div>
    </div>
</template>

<script>
import { payment, getexchangeRate } from "@/api/pay"

export default {
    data() {
        return {
            isactive: 1,
            disabled: false,
        };
    },
    computed: {
        userInfo() {
            // console.log(this.$store.state.userInfo)
            return this.$store.state.userInfo
        },
        isLoggedIn() {
            return this.$store.state.isLoggedIn;
        },
    },
    methods: {
        paymentguan() {
            this.$emit('paypopupguan')

        },
        changepay(value) {
            this.isactive = value
        },
        async pay() {
            this.disabled = true
            let money = this.isactive == 1 ? '1' : this.isactive == 2 ? '2.5' : this.isactive == 3 ? '5' : '50'
            localStorage.setItem("readerUrl", this.$route.fullPath);
            if (money < 0.4) {
                this.$message.warning("The minimum payment is 0.4 dollar")
            } else {
                try {
                    let exchangeRate = ''
                    try {
                        await getexchangeRate({
                            base: 'HKD',
                            target: 'USD'
                        }).then(res => {
                            console.log(res);
                            exchangeRate = res
                        })
                    } catch (err) {
                        exchangeRate = '7.8'
                    }
                    await payment({
                        payAmount: Math.round(money * 100 * exchangeRate),
                        bookId: this.$route.query.id,
                    }).then(res => {
                        localStorage.setItem("payMoney", money);
                        if (!res || res.code == 500) {
                            return this.$message.error("Network error")
                        }
                        window.location.href = res;
                    })
                } catch (error) {
                    alert("Network error");
                }
            }
        }
    },
    created() {
    }
};  
</script>

<style lang="less">
.payPopout {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 999999;
    background-color: transparent;

    .paychaper {
        width: 538px;
        height: 580px;
        padding: 40px;
        padding-top: 58px;
        transition: all 1s;
        box-sizing: border-box;
        position: relative;
        border-radius: 10px;
        border: 1px solid #EBEBEB;
        background: rgba(255, 255, 255, 0.90);
        box-shadow: 5px 5px 34.6px 0px #D5D5D5;

        .el-icon-close {
            position: absolute;
            right: 22px;
            top: 18px;
            font-size: 20px;
            cursor: pointer;
        }

        .paycoin {
            .pay {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                margin-top: 14px;

                .pays {
                    width: 214px;
                    height: 124px;
                    box-sizing: border-box;
                    border-radius: 12px;
                    position: relative;
                    padding: 20px;
                    padding-bottom: 38px;
                    background: #FFF;
                    border: 1px solid rgba(51, 51, 51, 0.20);
                    margin-bottom: 20px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    cursor: pointer;

                    .paycointit {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 18px;
                        margin-bottom: 4px;

                        image {
                            width: 30px;
                            height: 30px;
                        }
                    }

                    .cen {
                        font-size: 24px;
                        height: 30px;
                    }

                    .bot {
                        position: absolute;
                        height: 30px;
                        width: 100%;
                        bottom: 0;
                        border-radius: 0px 0px 12px 12px;
                        background: #F6F7F9;
                        font-size: 10px;
                        color: #646464;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    .tag {
                        width: 110px;
                        height: 28px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        left: 0;
                        transform: translateY(-130%);
                        color: #fff;
                        border-radius: 6px;
                        background: #CACACC;
                    }
                }

                .payactive {
                    border: 1.5px solid #E64716;

                    .tagis {
                        background-color: #E64716;
                    }
                }
            }

            .button {
                margin-top: 22px;
                height: 52px;
                width: 100%;
                border-radius: 16px;
                border-radius: 16px;
                background: #E64716;
                display: flex;
                justify-content: center;
                align-items: center;
                border: none;
                color: #fff;

            }
        }

        .but {
            height: 52px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-size: 18px;
            border-radius: 16px;
            background: #E64716;
            margin-bottom: 15px;
            border: none;
            cursor: pointer;
        }

        .but2 {
            border-radius: 16px;
            background: #CACACC;
        }
    }

    .warn {
        display: flex;
        margin-top: 20px;

        .el-icon-warning-outline {
            color: #E64716;
            font-size: 14px;
            margin-right: 4px;
            margin-top: 3px;
        }

        p {
            margin: 0;
            word-wrap: break-word;
            font-size: 14px;
            color: #646464;
        }
    }
}
</style>